<template>
  <p class="field search-field" :class="{ 'invalid': isInvalid }">
    <template v-if="autocomplete">
      <label :for="id">{{ label }}</label>
      <input
          ref="inputDom"
          type="text"
          :size="inputSize"
          :class="[commonInputClass, inputClass]"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="false"
          :autocomplete="browserAutocomplete"

          :minlength="minlength"
          :maxlength="maxlength"

          @input="handleModelInput"
          @focus="onFocus"
          @blur="onBlur"
      >
      <a
          v-if="itemId !== null && clearable"
          class="clearable_btn"
          :style="clearBtnStyle"
          :title="translations.clearText"
          @click.prevent="dropdownItemClicked(null)"
      >Vymazat</a>
      <div
          v-if="autocomplete && !autocompleteMultilevelOptions"
          class="extended_search"
          :class="{ 'extended': extended }"
      >
        <input
            type="hidden"
            :name="name"
            :value="itemId"
        />
        <ul>
          <li
              v-for="item in autocompleteMatches"
              :key="item._id"
              @click.prevent
          >
            <a
                @mousedown.prevent="dropdownItemClicked(item)"
                :inner-html.prop="getAutocompleteItemTitle(item) | highlight(valueCopy)"
            ></a>
          </li>
        </ul>
      </div>
      <div
          v-if="autocomplete && autocompleteMultilevelOptions"
          class="extended_search multilevel"
          :class="{ 'extended': extended }"
      >
        <input
            type="hidden"
            :name="name"
            :value="itemId"
        />
        <template v-for="section in autocompleteToplevelHeaders" v-if="valueCopy !== null && valueCopy !== ''">
          <h3 :key="section.type+'-title'">{{ section.name }}</h3>
          <ul
            :key="section.type+'-list'"
            class="scroll"
          >
            <li
                v-for="item in autocompleteMatchesByType(section.type)"
                :key="item._id+'-'+section.type"
                @click.prevent
            >
              <a
                  @mousedown.prevent="dropdownItemClicked(item)"
                  :inner-html.prop="getAutocompleteItemTitle(item) | highlight(valueCopy)"
              ></a>
            </li>
            <li v-if="dataPending">
              <a>{{ translations.loading }}</a>
            </li>
            <li v-if="!dataPending && (autocompleteMatchesByType(section.type).length === 0 && valueCopy !== null)">
              <a>{{ translations.noResults }}</a>
            </li>
          </ul>
        </template>
      </div>
    </template>

    <template v-else>
      <label :for="name">{{ fullLabel }}</label>
      <input
          v-if="type === 'email'"
          ref="inputDom"
          type="email"
          :size="inputSize"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          @input="handleModelInput"
      >
      <input
          v-else-if="type === 'url'"
          ref="inputDom"
          type="url"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          @input="handleModelInput"
      >
      <input
          v-else-if="type === 'number'"
          ref="inputDom"
          type="number"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model.number="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          :max="max"
          :min="min"
          :step="step"
          :minlength="minlength"
          :maxlength="maxlength"

          @input="handleModelInput"
      >
      <input
          v-else-if="type === 'password'"
          ref="inputDom"
          type="password"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          :max="max"
          :min="min"
          :step="step"

          @input="handleModelInput"
      >
      <input
          v-else-if="type === 'tel'"
          ref="inputDom"
          type="tel"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          @input="handleModelInput"
      >
      <input
          v-else-if="type === 'text'"
          ref="inputDom"
          type="text"
          :size="inputSize"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          :minlength="minlength"
          :maxlength="maxlength"

          @input="handleModelInput"
      >
      <a
          v-if="type=== 'text' && copyIcon"
          class="copy_icon"
          :title="translations.copyText"
          @click="copyName(valueCopy)"
      >
        {{ translations.copyText }}
      </a>
      <input
          v-else-if="type === 'search'"
          ref="inputDom"
          type="text"
          :size="inputSize"
          class="search"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          :minlength="minlength"
          :maxlength="maxlength"

          @input="handleModelInput"
          v-on:keydown.enter.prevent=""
      >
      <input
          v-else-if="type === 'numberSearch'"
          ref="inputDom"
          type="number"
          :size="inputSize"
          class="search"
          :class="[commonInputClass, inputClass]"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="browserAutocomplete"

          :minlength="minlength"
          :maxlength="maxlength"

          @input="handleModelInput"
          v-on:keydown.enter.prevent=""
      >
      <a
          v-if="(type === 'search' || type === 'numberSearch') && valueCopy !== '' && clearable"
          class="clearable_btn"
          :style="clearBtnStyle"
          :title="translations.clearText"
          @click.prevent="dropdownItemClicked(null)"
      >Vymazat</a>
      <span v-if="isInvalid" class="invalid_help">
        {{ error.msg }}
      </span>
    </template>
  </p>
</template>

<script>
import { propSatisfies, filter } from 'ramda'
import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'
import { getStringContains } from 'utils/helpers'
import { isNonEmptyString } from 'ramda-adjunct'

export default {
  name: 'app-input',
  props: {
    id: {
      type: String
    },
    name: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    copyIcon: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    error: {
      type: Object,
      default() {
        return {}
      }
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    step: {
      type: Number,
      default: null
    },
    minlength: {
      type: Number,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    browserAutocomplete: {
      type: String,
      default: null
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    autocompleteItem: {
      type: Object,
      default: null
    },
    autocompleteSource: {
      type: Array,
      default: () => []
    },
    autocompleteFilterResults: {
      type: Boolean,
      default: true
    },
    autocompleteMultilevelOptions: {
      type: Boolean,
      default: false
    },
    autocompleteToplevelHeaders: {
      type: Array,
      default: () => []
    },
    findAutocompleteOnCreate: {
      type: Boolean,
      default: false
    },
    dropdownClass: {
      type: String,
      default: ''
    },
    dropdownHolderClass: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputSize: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    pClass: {
      type: String,
      default: ''
    },
    order: {
      type: Number,
      default: null
    },
    dataPending: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.localFindAutocompleteOnCreate = this.findAutocompleteOnCreate
  },
  data() {
    return {
      valueCopy: null,
      itemId: null,
      autocompleteValidateMsg: 'Vyberte prosím položku ze seznamu',
      extended: false,
      focus: false,
      timer: null,
      localFindAutocompleteOnCreate: false
    }
  },
  beforeMount() {
    // Vue2 convention on custom v-model:
    // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
    this.copyValue(this.value)
  },
  mounted() {
    if (this.autocomplete) {
      if (this.required) {
        this.$refs.inputDom.setCustomValidity(this.autocompleteValidateMsg)
      }

      if (this.autocompleteItem) {
        this.dropdownItemClicked(this.autocompleteItem, true)
      }
    }
    if (this.$refs.inputDom.form) {
      this.$refs.inputDom.form.addEventListener('reset', this.onFormReset)
    }
  },
  beforeDestroy() {
    if (this.$refs.inputDom.form) {
      this.$refs.inputDom.form.removeEventListener('reset', this.onFormReset)
    }
  },
  computed: {
    translations() {
      return {
        clearText: this.$gettext('Vymazat text'),
        copyText: this.$gettext('Zkopírovat do orignálního názvu'),
        noResults: this.$gettext('Žádné výsledky'),
        loading: this.$gettext('Načítání')
      }
    },
    commonInputClass() {
      return {
        autocomplete: this.autocomplete
      }
    },
    autocompleteMatches() {
      if (this.autocompleteFilterResults) {
        const value = this.valueCopy

        if (isNonEmptyString(value)) {
          const containsSubstring = getStringContains(value)

          return filter(propSatisfies(containsSubstring, AUTOCOMPLETE_TITLE), this.autocompleteSource)
        }
      }

      return this.autocompleteSource
    },
    autocompleteInputDisabled() {
      return this.disabled || this.itemId !== null
    },
    fullLabel() {
      return this.label + (this.required ? ' *' : '')
    },
    clearBtnStyle() {
      if (this.valueCopy !== '') {
        return {
          display: 'inline-block'
        }
      }
    },
    isInvalid() {
      if (this.error.inputField) {
        return true
      } else {
        return 'field' in this.error
      }
    }
  },
  methods: {
    handleModelInput(event) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.$emit('input', event.target.value, event)
      }, 500)
    },
    copyName(value) {
      this.$emit('copyName', value)
    },
    copyValue(value) {
      this.valueCopy = value
    },
    getAutocompleteItemTitle(item) {
      return item[AUTOCOMPLETE_TITLE]
    },
    autocompleteMatchesByType(type) {
      return this.autocompleteMatches.filter(item => item.type == type);
    },
    dropdownItemClicked(item, noEmit) {
      this.$refs.inputDom.setCustomValidity((item || this.required) ? '' : this.autocompleteValidateMsg)
      this.itemId = item && item._id
      if (!this.clearable) {
        this.copyValue('')
      } else {
        this.copyValue((item && this.getAutocompleteItemTitle(item)) || '')
      }
      if (!noEmit) {
        this.$emit('autocompleteValueChanged', this.itemId, item)
        this.$emit('input', this.valueCopy)
      }
      this.$refs.inputDom.focus()
    },
    onFormReset() {
      this.itemId = null
      this.copyValue('')
      this.$emit('input', this.valueCopy)
    },
    onFocus() {
      if (this.autocompleteMatches.length > 0) {
        this.extended = true
      }
      this.focus = true
      this.$emit('focus')
      if (this.localFindAutocompleteOnCreate) {
        this.$emit('input', this.value)
        this.localFindAutocompleteOnCreate = false
      }
    },
    onBlur() {
      this.extended = false
      this.focus = false
      this.$emit('blur')
    },
    blur() {
      this.$refs.inputDom.blur()
    }
  },
  watch: {
    value(newValue) {
      // This watch works from the code side of the 2-way-binding:
      this.copyValue(newValue)
    },
    autocompleteItem(item) {
      this.dropdownItemClicked(item, true)
    },
    autocompleteMatches(items) {
      if (items.length > 0 && this.focus) {
        this.extended = true
      } else {
        this.extended = false
      }
    }
  }
}
</script>
